<template>
  <HeaderSection ref="header"></HeaderSection>
</template>

<script>
  import HeaderSection from "./HeaderSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";
  import { getCurrentInstance, onMounted } from "vue";

  export default {
    name: "HeaderWrapper",
    components: {
      HeaderSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
    setup() {
      const instance = getCurrentInstance();

      onMounted(() => {
        // In Vue 3, router-view refs don't expose child component refs automatically
        // So we register the header ref directly on the root component for backward compatibility
        const root = instance.proxy.$root;
        if (root && instance.refs.header) {
          // Create a direct reference path that bypasses the router-view
          if (!root.$headerComponent) {
            root.$headerComponent = instance.refs.header;
          }
        }
      });

      return {};
    },
  };
</script>
